import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAuth } from 'angular-auth-oidc-client';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { environment } from '@environments/environment';

import { routes } from './app.routes';
import { authInterceptor, cleanStaleAuthWellKnownCache } from './auth';
import { GlobalErrorHandler } from '@errors/global-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideBrowserGlobalErrorListeners(),
    provideAppInitializer(() => cleanStaleAuthWellKnownCache()),
    provideRouter(
      routes,
      withRouterConfig({
        canceledNavigationResolution: 'computed',
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAuth({ config: environment.authConfig }),
    provideIonicAngular({ useSetInputAPI: true }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'en',
    }),
    provideAppInitializer(() => firstValueFrom(inject(TranslateService).use('no')).catch(() => undefined))
  ],
};
